import React from "react";
import { Sparkle } from "@phosphor-icons/react";
import { DASHBOARD } from "@/constants/testIds";

export const PricingPlans = ({ plans = [] }) => {
    return (
        <section
            data-testid={DASHBOARD.pricing}
            className="rounded-lg border border-[#1f1f22] bg-[#080808] p-6 sm:p-8 lg:p-10"
        >
            <div className="mb-6 sm:mb-8">
                <span className="eviq-chip">Membership · Impact per plan</span>
                <h2 className="mt-4 font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl">
                    Pick a cadence. We handle the impact.
                </h2>
                <p className="mt-2 max-w-xl text-sm text-zinc-500">
                    A portion of every EVIQ membership quietly funds verified environmental and
                    veteran initiatives. No add-ons, no "donate" prompts.
                </p>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                {plans.map((p) => (
                    <div
                        key={p.id}
                        data-testid={DASHBOARD.plan(p.id)}
                        className={`relative flex flex-col rounded-lg border p-6 transition-colors duration-300 ${
                            p.featured
                                ? "border-[#a3e635]/50 bg-[#0a0f05] eviq-glow-green"
                                : "border-[#1f1f22] bg-[#0a0a0a] hover:border-[#3a3a3f]"
                        }`}
                    >
                        {p.featured && (
                            <div className="absolute -top-3 left-6 flex items-center gap-1 rounded-full bg-[#a3e635] px-3 py-1 font-mono-metric text-[10px] uppercase tracking-[0.16em] text-black">
                                <Sparkle size={12} weight="fill" />
                                Most impact
                            </div>
                        )}
                        <div className="flex items-baseline justify-between">
                            <h3 className="font-editorial text-2xl text-white">{p.name}</h3>
                            <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                                {p.cadence}
                            </span>
                        </div>
                        <div className="mt-4 flex items-end gap-2">
                            <span className="font-mono-metric text-4xl font-bold text-white sm:text-5xl">
                                ${p.price_usd}
                            </span>
                        </div>
                        <p className="mt-2 text-xs text-zinc-500">
                            Impact allocation: {p.impact_allocation_usd}
                        </p>
                        <div className="my-6 h-px bg-[#1f1f22]" />
                        <ul className="flex flex-col gap-2 text-sm text-zinc-300">
                            {p.highlights.map((h) => (
                                <li key={h} className="flex items-start gap-2">
                                    <span className="mt-2 h-1 w-1 flex-shrink-0 rounded-full bg-[#a3e635]" />
                                    {h}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-6 rounded-md border border-[#1f1f22] bg-[#050505] p-4">
                            <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                                Estimated impact
                            </span>
                            <p className="mt-2 text-sm leading-snug text-zinc-200">
                                {p.impact_summary}
                            </p>
                        </div>
                        <p className="mt-4 text-center font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-600">
                            Managed via EVIQ · display only
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default PricingPlans;
